export default function Profile() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <h1 className="text-3xl font-bold mb-6">Profile</h1>
      <p className="text-gray-400">Coming soon...</p>
    </div>
  )
}
